/*
 * @Description:
 * @Autor: ZY
 * @Date: 2020-12-07 10:30:20
 * @LastEditors: zhongbin.chen
 * @LastEditTime: 2021-12-11 16:07:23
 */
import { createApp, Directive } from 'vue'
import App from './App.vue'
// import './pwa/registerServiceWorker'
import router from './router'
import { store } from './store'
import { loadAllPlugins } from './plugins'
import '@/assets/iconfont/iconfont.css'
import '@/styles/index.scss'
import 'normalize.css'
import 'font-awesome/css/font-awesome.min.css'
import * as directives from '@/directives'
import '@/permission'
import i18n from '@/locales/index'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

//全局密码加密
import { AES_Encrypt, AES_Decrypt } from './utils/aes'


const app = createApp(App)
// 加载所有插件
app.use(i18n)
loadAllPlugins(app) 

// 自定义指令
Object.keys(directives).forEach(key => {
  app.directive(key, (directives as { [key: string ]: Directive })[key])
})

// el-icon图标处理
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.config.globalProperties.$AES_Encrypt = AES_Encrypt //全局加密
app.config.globalProperties.$AES_Decrypt = AES_Decrypt //全局解密

app.use(store).use(router).mount('#app')
